// removed by extract-text-webpack-plugin
module.exports = {"button":"_3PyXU","blackOverlay":"_3jijs"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PresentChannel.css
// module id = 862
// module chunks = 0